// STRUTTURA FORM

export const sectionsFirst = [
  {
    title: "Skills",
    rows: [
      "Predisposizione pareri legali",
      "Predisposizione contratti",
      "Predisposizione policy e procedure",
      "Ricerche",
      "Scrittura e-mail",
      "Formattazione",
      "Lingua inglese",
    ],
  },
  {
    title: "Knowledge",
    rows: [],
  },
  {
    title: "Business development",
    rows: [
      "Origination",
      "Networking",
      "Iniziative di knowledge",
      "Interesse per novità normative",
    ],
  },
];

export const sectionsSecond = [
  {
    title: "Self management",
    rows: [
      "Gestione dei tempi",
      "Problem solving",
      "Versatilità",
      "Capacità di uscire dalla propria comfort zone",
      "Gestione della pressione",
      "Adattamento alle innovazioni tecnologiche",
    ],
  },
  {
    title: "Internal relationship management – Team & firm",
    rows: [
      "Leadership verso le risorse più junior",
      "Team building",
      "Lavoro in squadra",
      "Comunicazione",
      "Disponibilità a supportare gli altri",
      "Partecipazione alla vita e ai valori dello studio",
    ],
  },
  {
    title: "Client management",
    rows: ["Leadership verso il cliente", "Empatia", "Chiarezza espositiva"],
  },
];

export const knowledgeByTeam = {
  "Corporate / M&A": [
    "Diritto societario",
    "Dinamiche di operazioni di M&A",
    "Dinamiche di operazioni di venture capital",
    "Gestione estemporanea di drafting di documentazione legale",
    "Prassi operative da applicare nel contesto di operazioni straordinarie",
  ],

  "LEXIA Corporate services": [
    "Diritto societario",
    "Dinamiche dell'attività di corporate services",
    "Gestione estemporanea di drafting di documentazione legale",
    "Prassi operative da applicare nel contesto delle operazioni",
    "Discernimento della rilevanza di un cliente in modo da creare valore aggiunto per gli altri team",
    "Principali altri servizi prestati dalla business unit Corporate Services (conoscenza base)",
  ],

  "Contenzioso e Arbritato": [
    "Diritto sostanziale (obbligazioni e contratti, società)",
    "Processo civile (cognizione, esecuzione, cautelare)",
    "Diritto internazionale privato",
    "Efficienza nella gestione della pratica",
    "Autonomia nella gestione del processo",
    "Efficacia ed efficienza della delega",
  ],

  "Lexia Private": [
    "Profili civilistici e fiscali della trasmissione del patrimonio inter vivos",
    "Profili civilistici e fiscali della trasmissione del patrimonio mortis causa",
    "Strumenti di pianificazione patrimoniale e successoria",
    "Diritto dei trusts",
    "Operazioni cross-border",
    "Redazione regolamenti di trust",
    "Progetti di pianificazione patrimoniale e successoria",
  ],

  "Capital Markets": [
    "Transactional (M&A, accordi di investimento)",
    "Corporate (governance, fusioni, scissioni)",
    "Disciplina degli emittenti su mercati regolamentati",
    "Disciplina degli emittenti su MTF",
    "Disciplina OPA",
    "Normativa in tema di prospetto",
  ],

  "Data & Technology Innovation": [
    "Protezione dei dati personali e privacy compliance (GDPR, normative nazionali e settoriali, data transfer, DPIA, MOP, Data Retention, etc.)",
    "Intelligenza artificiale e nuove tecnologie (AI Act, Legge n. 132/2025, governance e accountability dei sistemi di IA)",
    "Digital e IT contracts (contratti ICT, SaaS, cloud, outsourcing, marketplace, e-commerce, licenze software)",
    " Proprietà intellettuale (marchi, diritto d’autore)",
  ],

  "Accounting & Tax": [
    "Normativa IVA",
    "Normativa fiscale (TUIR)",
    "Gestione adempimenti fiscali ordinari",
  ],

  "Diritto fallimentare": [
    "Strumenti di risoluzione della crisi (generale)",
    "Attivazione principali strumenti di risoluzione della crisi e CNC",
    "Redazione atti giudiziari per procedure concorsuali, strumenti di regolazione della crisi e contenzioso generico",
    "Redazione documenti stragiudiziali in tema (accordi: in esecuzione di piani attestati, di ristrutturazione, di moratoria)",
    "Redazione altri documenti stragiudiziali (es. contratti di affitto o altre tipologie)",
  ],
};
